import { ScrollOrientation } from '@epicuro-next/ataraxia/scroll-buttons';
import { IDynamicInput } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

import { createScrollablePanel } from '../components/panels/scrollable-panel';

export type NoItemsViewDefaultProperties = {
  icon?: IDynamicInput;
  text: IDynamicInput;
};

export class ScrollableRecommendationPanelBuilder {
  private orientation: ScrollOrientation = ScrollOrientation.horizontal;

  constructor() {}

  public setOrientation(orientation: ScrollOrientation) {
    this.orientation = orientation;
    return this;
  }

  public build() {
    const scrollablePanel = createScrollablePanel(this.orientation);

    const valuesToReturn = { scrollablePanel };
    return JSON.parse(JSON.stringify(valuesToReturn)) as typeof valuesToReturn;
  }
}
